export default "__VITE_ASSET__D_CzQxMi__"